import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from '@gatsbyjs/reach-router'
import App from './app'
import serverData, { init as initServerData } from './utils/server-data'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'

initServerData()
let root = document.getElementById('root')

if (!root) {
  root = document.createElement('div')
  document.body.appendChild(root)
}

ReactDOM.render(
  <WorldReadyContextProvider locale={serverData.locality.locale}>
    <Router basepath={serverData.requestURI}>
      <App path="*" />
    </Router>
  </WorldReadyContextProvider>,
  root,
)
